// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/widgets/browserWidget.styl
// module id = 414
// module chunks = 0